/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
//"use strict";
// 17280  11112    this.MULTIPLIER
expocadfx.config = {
    isXML: false, // Flag to switch between local files or SQL server application
    MULTIPLIER : 1,
    DRAWING_WIDTH : 5760,
    DRAWING_HEIGHT : 3704,
    MINI_MAP_WIDTH : 264,
    MINI_MAP_HEIGHT : 200,
    MINI_MAP_SCALE : 0,
    FLOOR_PLAN_FONT : "Arial",
	DISABLED_GRAY : "#bfbfbf",
    is3d : true,
    BOOTH_ALPHA : 0.8,
    PAVILION_ALPHA : 0.6,
    PAVILION_COLOR : "#0000ff",
    GRAPHIC_ALPHA : 0.7,
    FAVORITE_CHARACTER_CODE: 0xf005,    /* characters from FontAwsome */
    SELECTED_CHARACTER_CODE: 0xf041,
    bannerHeight : 60,
    bannerMargin : 8,
    clrBackground : "#ffffff",
    buildingColor : "default",		
    clrRent : "",
    clrHold : "#F0F0F0",
    clrAvailable : "#ADD8E6",
    clrSelected : "#FFFF00",
    clrHighlight : "#FF0000",
    clrBoothText : "#000000",
    clrBuildingText : "#808080",
    clrBoothBase : "#dddddd",
    clrBoothBorder : "#dddddd",
	clrBoothDimensions : "#B8860B",
	boothBorderLineWidth : 1,
	additionalGraphicsLineWidth : 1,
    fileNumber : 0,
    contactEmail : "cfihcdgjkecfdbabegfchbe",
    availableUrl : "",
    availableText1 : "",
    availableText2 : "NA",
    emailSubject0 : "",
    emailSubject1 : "Request to Rent Booth ",
    emailSubject2 : "",
    checkSum : 0,
    year : 0,
    month : 0,
    day : 0,
    eventTitle : "",
    eventTitleLocation : "header",
    clrEventTitleText : "#000000",
    eventTitleTextSize : "24",
    eventTitleCoordinates : null,
    eventName : "",
    apiView : "",
    viewName : "",
    viewTitle : "",
    viewTitleLocation : "header",
    clrViewTitleText : "",
    viewTitleTextSize : "20",
    viewTitleCoordinates : null,
    updateCheckInterval : "",
    units : "",           /*  current  */
    showUnits : "",
    hasMultipleViews :  false,
    bSocialButtons : false,
	showDimensions : false,
    
    bPDF : false,
    bFloorPlanPrint : true,
    bIAmHere : true,
    bBuilding : true,
    bListPrint : true,
    bPopUpPrint : true,
    bPopUpShare : true,
    bPopUpPDF : false,
    bUnitsButton : true,
    
    bUrl : false,
    bPreviewLink : false,
    bOverlay : false, 
    bDataEncrypted : false,

    bServerTime : false,
    serverTimeOffset : 0,
    serverTimeColor : "#000000",
    serverTimeZoneLabel : "",
    serverTimeXML : null,
	
    bLegend : true,
	legendOpen: true,
	legendRent: true,
	legendHold: true,
	legendAvailable: true,
	clrLegendBackground: "",
	LegendBackgroundAlpha: 0.75,
	LegendTextColor: "",
	legendFontSize: "",
    legendUseClassId : false,

    savedDate : "",
    savedTime : "",
    scaleFactor : "",
    version : "",
    expocadVersion : "",
    oldVersion : false,

    bCategoryData : false,
    bPavilionData : false,
    bSubShowData : false,
    bCountryData : false,
    
    hasFloorPlan : true,
    
    showLists : true,
    AccordionDefaultList : "",
	defaultListWindowOpen : true,

    bHideAvailableList: false,
    bHideCountryList: true,
    bHideFloorPlanDate: false,
    bMiniMap : true,
    bMiniMapOpen : true,
    bMapAddress : true,
    bToolbar : true,
	bDimensions : true,
	
	clrFlyoutBackground: "",
	clrFlyoutText: "",
	flyoutFontSize: "",
    
    rentMode: false,
    holdMode: false,
    holdModeExhibitorName: false,
    combineAdjacentOnly: false,
    
    urlFacilityView : "",
	languages: [],
	defaultlanguage: "",
    xmlBoothClasses : null,
    arBoothClasses : [],
    
    bBoothGradient : false,
    /*  how to use booth colors from EXPOCAD graphics file  */
    borderAvailableWithExpocadColor : false,
    borderOnHoldWithExpocadColor : false,
    borderRentedWithExpocadColor : false,
    fillAvailableWithExpocadColor : false,
    fillOnHoldWithExpocadColor : false,
    fillRentedWithExpocadColor : false,
    
    initialExhibitorFilter : "view",
    initialAllExhibitors : false,
    initialPage : "exhibitors",    /* floorplan|pavilion|category-from FLASH version-set from 'DefaultList'*/
	
    hdrLogoSource : "",
    password : "",
    lastSaved : "",
    authorizationKey : "",
    activationCode: "",
    showCoords : false,
    salesMode : "none",
	salesUpdateOnly: false,
    sortRatePlans : "none",
	gaAccount: null,				/*  move from fxData  */
    
    bUseApi : true,
    
    openIn3D: false,
    elvis: false,		/*  Emergency Location (Visual) Interactive (Service) - officially ELI  */
    elvisNumbers: [],
    elvisMessages: [],

    printLayoutAdjustmentX: 0, // Upper left coord from printLayout object
	printLayoutAdjustmentY: 0,
	printLayoutOrientation: 0,
	printLayoutScale: 0.045833, // PDF points == this library uses 72px per inch
    
    optionsSet: "none",

    locationAvailable: false,
    locationEnabled: false,
    locationUpdateCheckInterval : 3000,

    refLat0: 0,
    refLon0: 0,
    refLat1: 0,
    refLon1: 0,
    
    refFXX0: 0,
    refFXY0: 0,
    refFXX1: 0,
    refFXY1: 0,
    
    lastXY: [],

    redirectToDirectory: false,
    noNav: false,
    attendeeLogin: false,
    exhibitorDirectory: false,
    currencySymbol: null, 
    currencySymbolBefore: true,
    loggedInExhib: "",
    bWayData: false,

    showActiveCartSales: false,
    showActiveCartExhib: false,
    activeCartColor: "#FFFF00"
};

// Populate config array from Datsun endpoint
function setConfig(res){
    expocadfx.config.MULTIPLIER = res.MULTIPLIER,
    expocadfx.config.DRAWING_WIDTH = res.DRAWING_WIDTH,
    expocadfx.config.DRAWING_HEIGHT = res.DRAWING_HEIGHT,
    expocadfx.config.MINI_MAP_WIDTH = res.MINI_MAP_WIDTH,
    expocadfx.config.MINI_MAP_HEIGHT = res.MINI_MAP_HEIGHT,
    expocadfx.config.MINI_MAP_SCALE = res.MINI_MAP_SCALE,
    expocadfx.config.FLOOR_PLAN_FONT = res.FLOOR_PLAN_FONT,
	expocadfx.config.DISABLED_GRAY = res.DISABLED_GRAY,
    expocadfx.config.BOOTH_ALPHA = res.BOOTH_ALPHA,
    expocadfx.config.PAVILION_ALPHA = res.PAVILION_ALPHA,
    expocadfx.config.PAVILION_COLOR = res.PAVILION_COLOR,
    expocadfx.config.GRAPHIC_ALPHA = res.GRAPHIC_ALPHA,
    expocadfx.config.FAVORITE_CHARACTER_CODE= res.FAVORITE_CHARACTER_CODE,    /* characters from FontAwsome */
    expocadfx.config.SELECTED_CHARACTER_CODE= res.SELECTED_CHARACTER_CODE,
    expocadfx.config.bannerHeight = res.bannerHeight,
    expocadfx.config.bannerMargin = res.bannerMargin,
    expocadfx.config.clrBackground = res.clrBackground,
    expocadfx.config.buildingColor = res.buildingColor,		
    expocadfx.config.clrRent = res.clrRent,
    expocadfx.config.clrHold = res.clrHold,
    expocadfx.config.clrAvailable = res.clrAvailable,
    expocadfx.config.clrSelected = res.clrSelected,
    expocadfx.config.clrHighlight = res.clrHighlight,
    expocadfx.config.clrBoothText = res.clrBoothText,
    expocadfx.config.clrBuildingText = res.clrBuildingText,
    expocadfx.config.clrBoothBase = res.clrBoothBase,
    expocadfx.config.clrBoothBorder = res.clrBoothBorder,
	expocadfx.config.clrBoothDimensions = res.clrBoothDimensions,
	expocadfx.config.boothBorderLineWidth = res.boothBorderLineWidth,
	expocadfx.config.additionalGraphicsLineWidth = res.additionalGraphicsLineWidth,
    expocadfx.config.fileNumber = res.fileNumber,
    expocadfx.config.contactEmail = res.contactEmail,
    expocadfx.config.availableUrl = res.availableUrl,
    expocadfx.config.availableText1 = res.availableText1,
    expocadfx.config.availableText2 = res.availableText2,
    expocadfx.config.emailSubject0 = res.emailSubject0,
    expocadfx.config.emailSubject1 = res.emailSubject1,
    expocadfx.config.emailSubject2 = res.emailSubject2,
    expocadfx.config.checkSum = res.checkSum,
    expocadfx.config.year = res.year,
    expocadfx.config.month = res.month,
    expocadfx.config.day = res.day,
    expocadfx.config.eventTitle = res.eventTitle,
    expocadfx.config.eventTitleLocation = res.eventTitleLocation,
    expocadfx.config.clrEventTitleText = res.clrEventTitleText,
    expocadfx.config.eventTitleTextSize = res.eventTitleTextSize,
    expocadfx.config.eventTitleCoordinates = res.eventTitleCoordinates,
    expocadfx.config.eventName = res.eventIdentifier,
    expocadfx.config.viewName = res.viewName,
    expocadfx.config.viewTitle = res.viewTitle,
    expocadfx.config.viewTitleLocation = res.viewTitleLocation,
    expocadfx.config.clrViewTitleText = res.clrViewTitleText,
    expocadfx.config.viewTitleTextSize = res.viewTitleTextSize,
    expocadfx.config.viewTitleCoordinates = res.viewTitleCoordinates,
    expocadfx.config.updateCheckInterval = res.updateCheckInterval,
    expocadfx.config.locationUpdateCheckInterval = 3000,
    expocadfx.config.units = res.units,           /*  current  */
    expocadfx.config.showUnits = res.showUnits,
    expocadfx.config.hasMultipleViews =  config.viewAll ? true : res.hasMultipleViews,
    expocadfx.fxData.arViews = res.views ? res.views : [],
    expocadfx.config.bSocialButtons = res.bSocialButtons,
    expocadfx.config.jsonSocial = res.arSocial,
	expocadfx.config.showDimensions = res.showDimensions,
    
    expocadfx.config.bPDF = res.bPDF,
    expocadfx.config.bFloorPlanPrint = res.bFloorPlanPrint,
    expocadfx.config.bIAmHere = res.bIAmHere,
    expocadfx.config.bBuilding = res.bBuilding,
    expocadfx.config.bListPrint = res.bListPrint,
    expocadfx.config.bPopUpPrint = res.bPopUpPrint,
    expocadfx.config.bPopUpShare = res.bPopUpShare,
    expocadfx.config.bPopUpPDF = true, //res.bPopUpPDF,
    expocadfx.config.bUnitsButton = res.bUnitsButton,
    
    expocadfx.config.bUrl = res.bUrl,
    expocadfx.config.bPreviewLink = res.bPreviewLink,
    expocadfx.config.bOverlay = res.bOverlay, 
    expocadfx.config.bDataEncrypted = res.bDataEncrypted,

    expocadfx.config.bServerTime = res.bServerTime,
    expocadfx.config.serverTimeOffset = res.serverTimeOffset,
    expocadfx.config.serverTimeColor = res.serverTimeColor,
    expocadfx.config.serverTimeZoneLabel = res.serverTimeZoneLabel,
	
    expocadfx.config.bLegend = res.bLegend,
	expocadfx.config.legendOpen= res.legendOpen,
	expocadfx.config.legendRent= res.legendRent,
	expocadfx.config.legendHold= res.legendHold,
	expocadfx.config.legendAvailable= res.legendAvailable,
	expocadfx.config.clrLegendBackground= res.clrLegendBackground,
	expocadfx.config.LegendBackgroundAlpha= res.LegendBackgroundAlpha,
	expocadfx.config.LegendTextColor= res.LegendTextColor,
	expocadfx.config.legendFontSize= res.legendFontSize,
    expocadfx.config.legendUseClassId = res.legendUseClassId, 

    expocadfx.config.savedDate = res.savedDate,
    expocadfx.config.savedTime = res.savedTime,
    expocadfx.config.scaleFactor = res.scaleFactor,
    expocadfx.config.version = res.version,
    expocadfx.config.expocadVersion = res.expocadVersion,
    expocadfx.config.oldVersion = res.oldVersion,

    expocadfx.config.bCategoryData = res.bCategoryData,
    expocadfx.config.bPavilionData = res.bPavilionData,
    expocadfx.config.bSubShowData = res.bSubShowData,
    expocadfx.config.bCountryData = res.bCountryData,
    
    expocadfx.config.hasFloorPlan = res.hasFloorPlan,
    
    expocadfx.config.showLists = res.showLists,
    expocadfx.config.AccordionDefaultList = res.AccordionDefaultList,
	expocadfx.config.defaultListWindowOpen = res.defaultListWindowOpen,

    expocadfx.config.bHideAvailableList= res.bHideAvailableList,
    expocadfx.config.bHideCountryList= res.bHideCountryList,
    expocadfx.config.bHideFloorPlanDate= res.bHideFloorPlanDate,
    expocadfx.config.bMiniMap = res.bMiniMap,
    expocadfx.config.bMiniMapOpen = res.bMiniMapOpen,
    expocadfx.config.bMapAddress = res.bMapAddress,
    expocadfx.config.bToolbar = res.bToolbar,
	expocadfx.config.bDimensions = res.bDimensions,
	
	expocadfx.config.clrFlyoutBackground= res.clrFlyoutBackground,
	expocadfx.config.clrFlyoutText= res.clrFlyoutText,
	expocadfx.config.flyoutFontSize= res.flyoutFontSize,
    
    expocadfx.config.rentMode= res.rentMode,
    expocadfx.txt.RENT_MODE_LABEL = res.rentModeExhibitorName,
    expocadfx.config.holdMode= res.holdMode,
    expocadfx.txt.HOLD_MODE_LABEL = res.holdModeExhibitorName,
    expocadfx.config.holdModeExhibitorName= res.holdModeExhibitorName,
    expocadfx.config.combineAdjacentOnly = res.combineAdjacentOnly,
    
    expocadfx.config.urlFacilityView = res.urlFacilityView,
	expocadfx.config.languages= res.languages,
	expocadfx.config.defaultLanguage= res.defaultLanguage,
    expocadfx.config.xmlBoothClasses = res.xmlBoothClasses,
    expocadfx.config.arBoothClasses = res.arBoothClasses,
    
    expocadfx.config.bBoothGradient = res.bBoothGradient,
    /*  how to use booth colors from EXPOCAD graphics file  */
    expocadfx.config.borderAvailableWithExpocadColor = res.borderAvailableWithExpocadColor,
    expocadfx.config.borderOnHoldWithExpocadColor = res.borderOnHoldWithExpocadColor,
    expocadfx.config.borderRentedWithExpocadColor = res.borderRentedWithExpocadColor,
    expocadfx.config.fillAvailableWithExpocadColor = res.fillAvailableWithExpocadColor,
    expocadfx.config.fillOnHoldWithExpocadColor = res.fillOnHoldWithExpocadColor,
    expocadfx.config.fillRentedWithExpocadColor = res.fillRentedWithExpocadColor,
    
    expocadfx.config.initialExhibitorFilter = res.initialExhibitorFilter,
    expocadfx.config.initialAllExhibitors = res.initialAllExhibitors,
    expocadfx.config.initialPage = res.initialPage,    /* floorplan|pavilion|category-from FLASH version-set from 'DefaultList'*/
	
    expocadfx.config.hdrLogoSource = res.hdrLogoSource,
    expocadfx.config.password = res.password,
    expocadfx.config.lastSaved = res.lastSaved,
    expocadfx.config.authorizationKey = res.authorizationKey,
    expocadfx.config.showCoords = res.showCoords,
    //expocadfx.config.salesMode = "sales",//res.salesMode,
    expocadfx.fxData.salesUrl = window.location.origin + "/EdgeApi/" + res.eventIdentifier + "/",
    //expocadfx.fxData.salesAllowedCommands = String("0,1,4,5,2,3,6,7,8,9,11,12,10").split(","),
    expocadfx.fxData.salesAllowedCommands = String(res.permissions).split(","),
    expocadfx.fxData.lastMessageNumber = res.lastRecordNumber,

    expocadfx.config.is3d = res.is3d,
	expocadfx.config.salesUpdateOnly= res.salesUpdateOnly,
    expocadfx.config.sortRatePlans = res.sortRatePlans,
	expocadfx.fxData.gaAccount= res.gaAccount,				/*  move from fxData  */ //Move back to fxData? 4/5/2021 -AH
    
    expocadfx.config.openIn3D= res.openIn3D,
    expocadfx.config.elvis= res.elvis,		/*  Emergency Location (Visual) Interactive (Service) - officially ELI  */
    expocadfx.config.elvisNumbers= res.elvisNumbers,
    expocadfx.config.elvisMessages= res.elvisMessages,
    expocadfx.config.locationAvailable = false,
    expocadfx.config.locationEnabled = false,
    expocadfx.config.redirectToDirectory = false, //res.redirectToDirectory,
    expocadfx.config.attendeeLogin = res.attendeeLogin,
    expocadfx.config.serverTimeXML = res.serverTimeXML,
    //expocadfx.config.noNav = res.noNav,
    expocadfx.config.exhibitorDirectory = !res.noNav,
    expocadfx.fxData.premiumLevels = res.premiumLevels,
    expocadfx.fxData.premiumCompanies = res.premiumCompanies,
    expocadfx.config.currencySymbol = res.currencySymbol,
    expocadfx.config.currencySymbolBefore = res.currencySymbolBefore,
    expocadfx.config.showActiveCartSales = res.showActiveCartSales,
    expocadfx.config.showActiveCartExhib = res.showActiveCartExhib,
    expocadfx.config.activeCartColor = res.activeCartColor,

/* Set expocadfx.styles here as well - for UI colors
expocadfx.styles = {
    mainHeader : { clrBg: "#0073a8", clrText: "#FFFFFF", gradBg: "" },
    windowHeader : { clrBg: "#0073a8", clrText: "#FFFFFF", gradBg: "" },
    footer : { clrBg: "#0073a8", clrText: "#000000", gradBg: "" },
    exhibitor : { clrBg: "#83ADCF", clrText: "#FFFFFF", gradBg: "" },
    floorplan : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },   //small layout only
    home : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    category : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    pavilion : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    subShow : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    country : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    view : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    availableBooth : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    
    rows : { clrOddBg: "#D8EDF3", clrOddText: "#000000", clrEvenBg: "#F0F8FF", clrEvenText: "#000000"},
    fpToolbar: { clrBg: "#0073a8", clrText: "#FFFFFF", alpha: "1.0"}
    
}; */

    expocadfx.styles.mainHeader = res.uiMainHeader;
    expocadfx.styles.windowHeader = res.uiWindowHeader;
    expocadfx.styles.footer = res.uiFooter;
    expocadfx.styles.exhibitor = res.uiExhibitor;
    expocadfx.styles.floorplan = res.uiFloorplan;
    expocadfx.styles.home = res.uiHome;
    expocadfx.styles.category = res.uiCategory;
    expocadfx.styles.pavilion = res.uiPavilion;
    expocadfx.styles.subShow = res.uiSubShow;
    expocadfx.styles.country = res.uiCountry;
    expocadfx.styles.view = res.uiView;
    expocadfx.styles.availableBooth = res.uiAvailableBooth;
    expocadfx.styles.rows = res.uiRows;
    expocadfx.styles.fpToolbar = res.uiFpToolbar;

}